//I love Edge, missing flatMap up to version 78

if (Array.prototype.flatMap === undefined) {
  Array.prototype.flatMap = function (lambda) {
    return Array.prototype.concat.apply([], this.map(lambda))
  }
}
